// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"618e5289af6cd98960ec","655":"215b55874d634583d63a"}[chunkId] + ".js";
};